import React, {Component} from 'react';
import NavBar from './NavBar';
import Container from 'react-bootstrap/Container';
import {FormattedMessage} from 'react-intl';
import {withRouter} from 'react-router-dom';

import './Header.css';
import {Button, Col, Row} from 'react-bootstrap';
import {toggleTour} from "../Redux/action";
import {connect} from "react-redux";

class Header extends Component {



    constructor(props) {
        super(props);

        this.state = {
            currentPathIsHome: true,
        };

        this.props.history.listen((location, action) => {
            if (location.pathname === '/') {
                this.setState({
                    currentPathIsHome: true,
                });
            } else {
                this.setState({
                    currentPathIsHome: false,
                });
            }
        });

    }

    componentDidMount() {
        if (this.props.history.location.pathname !== '/') {
            this.setState({
                currentPathIsHome: false,
            });
        }
    }
    startTour= () => {

    }

    render() {
        return (
            <header>
                <NavBar/>

                <Container className="header-content mt-3 pb-3 pt-3">
                    <Row>
                        <Col lg={12}>
                            <div className="main-title">
                                <h4 className=''><FormattedMessage id="header.welcome"/></h4>

                                {
                                    this.state.currentPathIsHome
                                    &&
                                    <Button size="lg" variant="outline-secondary" className="btn-tutorial" onClick={()=>{this.props.toggleTour(true)}}><FormattedMessage id="header.start-tour"/></Button>
                                }
                            </div>

                        </Col>
                    </Row>
                </Container>
            </header>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        toggleTour: (the_state) => dispatch(toggleTour(the_state))
    }
}
export default connect(null, mapDispatchToProps) (withRouter(Header));
